/*****************************************************************************************************
 * Load Libraries
 */

require('slick-carousel');
import CollapsibleButton from '../services/collapsible/CollapsibleButton';
import Collapsible from '../services/collapsible/Collapsible';
import vSelect from 'vue-select';

global.CollapsibleButton = CollapsibleButton;
global.Collapsible = Collapsible;

/*****************************************************************************************************
 * Load All Internal Components
 */

// Vue
window.Vue = require('vue').default;
window.Vue.use(require('vue-cookies'));


window.Vue.component('fake-checkbox', require('@RESOURCES/js/components/FakeCheckboxComponent.vue').default);
window.Vue.component('subscription-form', require('@RESOURCES/js/components/subscription/SubscriptionForm').default);
window.Vue.component('header-quick-links-tw', require('@RESOURCES/js/components/tailwind/home/HeaderQuickLinks').default);
window.Vue.component('go-to-user-geo-tw', require('@RESOURCES/js/components/tailwind/home/GoToUserGeo').default);
window.Vue.component('geo-link-tw', require('@RESOURCES/js/components/tailwind/home/GeoLink').default);
window.Vue.component('show-more-show-less-button', require('@RESOURCES/js/components/operator_list/ShowMoreShowLessButton.vue').default);

//Articles
window.Vue.component('article-item', require('@RESOURCES/js/components/articles/ArticleItem.vue').default);
window.Vue.component('article-featured', require('@RESOURCES/js/components/articles/ArticleFeatured.vue').default);
window.Vue.component('articles-global', require('@RESOURCES/js/components/articles/ArticlesGlobal.vue').default);
window.Vue.component('selector', require('@RESOURCES/js/components/Selector.vue').default);
window.Vue.component('newsletter-modal', require('@RESOURCES/js/components/NewsletterModal.vue').default);


//Vue-Select
window.Vue.component('v-select', vSelect)
window.Vue.component('switch-button', require('@RESOURCES/js/components/SwitchButton').default);

window.Vue.component('newsletter-modal-tw', require('@RESOURCES/js/components/tailwind/NewsletterModal.vue').default);
window.Vue.component('subscription-form-tw', require('@RESOURCES/js/components/tailwind/SubscriptionForm.vue').default);
window.Vue.component('show-more-show-less-button-tw', require('@RESOURCES/js/components/tailwind/operator_list/ShowMoreShowLessButton.vue').default);
window.Vue.component('fake-checkbox-tw', require('@RESOURCES/js/components/tailwind/FakeCheckboxComponent.vue').default);



window.addEventListener('DOMContentLoaded', function () {
    $('.slider-corporate-logos').slick({
        infinite: true,
        arrows: true,
        dots: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        // variableWidth: true, strange behaviour on iphone
        prevArrow: '<div class="ml-3 slick-arrow slick-prev flex items-center"><img alt="Prev Arrow"/></div>',
        nextArrow: '<div class="mr-3 slick-arrow slick-next flex items-center"><img alt="Next Arrow"/></div>',
        responsive: [
            {
                breakpoint: 420,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 470,
                settings: {
                    slidesToShow: 1,
                }
            }, {
                breakpoint: 550,
                settings: {
                    slidesToShow: 2,
                }
            }, {
                breakpoint: 700,
                settings: {
                    slidesToShow: 3,
                }
            }, {
                breakpoint: 850,
                settings: {
                    slidesToShow: 4,
                }
            }, {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 5,
                }
            }]
    });

    // Init Geo Link Component
    if (document.querySelector('#geo_link')) {
        new Vue({
            el: '#geo_link',
        });
    }
});
